export const limitCharacters = (s: string, n: number) => (s?.length > n ? `${s?.slice(0, n)}...` : s);
